import { useId } from 'vue'

import type { JWT } from '@/types/Common'

const decodeBase64Url = (value: string): string => {
    const base64 = value.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=')
    const bytes = Uint8Array.from(atob(padded), char => char.charCodeAt(0))
    return new TextDecoder().decode(bytes)
}

export const parseJwt = (token: string): JWT | null => {
    if (!token) return null

    const splitToken = token.split('.')
    if (splitToken.length !== 3) return null

    const payloadData = token.split('.')[1] ?? ''

    return JSON.parse(decodeBase64Url(payloadData))
}

export const generateRandomId = (prefix = ''): string => {
    prefix = prefix ? `${prefix}-` : ''
    return `${prefix}${useId()}`
}

export const nullDate = '0001-01-01'
export const MongoDBNullId = '000000000000000000000000'
